import {
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import React from 'react';



export type ActivityDetailCardEmptyStateLayoutProps = {
  title: string;
  description: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivityDetailCardEmptyStateLayoutProps) => {
  const theme = useTheme();
  return (
    <Stack
      rowGap='1rem'
      direction='column'
      justifyContent='center'
      alignItems='center'
      height='12rem'
      bgcolor={theme.palette.customGray.light}
    >
      <CustomIcon.large.FC
        icon='EMPTY'
        stroke={theme.palette.primary.main}
      />
      <Typography
        variant='bodyBold'
      >
        {props.title}
      </Typography>
      <Typography
        variant='body2'
      >
        {props.description}

      </Typography>
    </Stack>
  );
};
